"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsx jsx */
const react_1 = require("@emotion/react");
const b_1 = __importDefault(require("b_"));
const times_1 = __importDefault(require("lodash/times"));
const i18n_1 = __importDefault(require("@yandex-int/pythia-libs/lib/i18n"));
const watermark_styles_1 = __importDefault(require("./watermark.styles"));
const b = b_1.default.with('watermark');
function WatermarkComponent() {
    const i18n = (0, i18n_1.default)(['page']);
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: b() }, { children: [(0, jsx_runtime_1.jsx)(react_1.Global, { styles: watermark_styles_1.default }), (0, times_1.default)(25).map(i => ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: b('row') }, { children: i18n(['watermark']) }), i)))] })));
}
exports.default = WatermarkComponent;
